export default __webpack_public_path__ + "static/media/bg.6bf282fb.gif";